export default __webpack_public_path__ + "static/media/insta-icon.77b6532b.svg";